/*  UI  */
import { Box } from '@auviknetworks/iceberg-ui';

/*  Shared  */
import { UserGreeting } from 'application/Shared/Components/App';
import { Dashboard } from 'application/Shared/Components/Dashboard';

/*  Types  */
import { Dashboard as DashboardType } from 'application/Shared/Components/Dashboard/types';

/*  React  */
import React from 'react';

/*  Data  */
import dashboard from './pathfinder.json';

export const Pathfinder = () => (
    <>
        <Box sx={{ marginBottom: '24px' }}>
            <UserGreeting />
        </Box>
        <Dashboard dashboard={dashboard as DashboardType} />
    </>
);
